import React from 'react';
import { Jumbotron as Jumbo, Container } from 'react-bootstrap';
import styled from 'styled-components';
import {Layout} from './components/Layout';
import {Jumbotron} from './components/Jumbotron5';

const Styles=styled.div`

@media only screen and (min-width: 1001px) {


.gif{
float:left;
width:45%;
border: 2px solid black;
margin-bottom:250px;
margin-right:50px;
margin-left:50px;
}

.text{
margin-left:400px;
margin-right:50px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
}

.text1{
font-family: 'Open Sans', sans-serif;
margin-right:900px;
margin-left:90px;
margin-top:50px;
text-align:left;
font-size:24px;
}

.psd2{
float:right;
width:25%;
margin-top:-75px;
margin-right:250px;
border: 2px solid black;

}
.email{
float:left;
width:45%;
margin-top:80px;
margin-right:100px;
margin-left:50px;
margin-bottom:300px;
border: 2px solid black;

}

.title{
font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:200px;
margin-left:90px;

}
.text2{
font-family: 'Open Sans', sans-serif;
margin-top:50px;
text-align:left;
font-size:24px;
margin-right:30px;
margin-left:300px;
margin-bottom:100px;

}
.title2{

font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:500px;
text-align:left;
margin-right:50px;
margin-left:1000px;
color:#0080b9;
}
mark.blue{
	color:#0080b9;
	background: none;
	margin-left:-5px;
	font-weight:bold;
}
.design{
float:right;
width:50%;
margin-top:-30px;
margin-right:50px;
margin-bottom:200px;
margin-left:60px;
border: 2px solid black;
}
.text3{
font-family: 'Open Sans', sans-serif;
margin-top:450px;
margin-bottom:100px;
margin-left:100px;
text-align:left;
font-size:24px;
}
}

@media only screen and (max-width: 1000px) {

.gif{
width:100%;
}
.text{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;

}
.title{
font-family: 'Open Sans', sans-serif;
font-size:60px;
color:#0080b9;
margin-top:40px;
padding-top:40px;
text-align:center;
}
.psd2{
width:95%;
margin-top:30px;
margin-bottom:3px;
margin-right:10px;
margin-left:10px;
border: 2px solid black;
}
.text1{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;
}
.email{
width:95%;
margin-top:30px;
margin-bottom:3px;
margin-left:10px;
margin-right:10px;
border: 2px solid black;
}
.text2{
margin-left:15px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-top:40px;
margin-right:15px;
margin-bottom:150px;
}
.title2{

font-family: 'Open Sans', sans-serif;
font-size:69px;
color:#0080b9;
margin-top:50px;
margin-bottom:20px;
text-align:center;
margin-right:40px;
padding-top:40px;
color:#0080b9;
}
mark.blue{
	color:#0080b9;
	background: none;
	margin-left:-5px;
	font-weight:bold;
}
.design{
width:90%;
margin-top:-50px;
margin-right:30px;
margin-bottom:20px;
margin-left:20px;
border: 2px solid black;
}
.text3{
font-family: 'Open Sans', sans-serif;
margin-top:45px;
margin-bottom:100px;
margin-left:10px;
text-align:left;
font-size:24px;
}
}

`;
export const Sanmina = () => (
<React.Fragment>
	<Jumbotron />
		
	<Styles>
		

<img src={require('./assets/sanmina.png')} alt="Sanmina Logo" Class="gif"/> 	
	<div class="text">
	<p>In 2015, I joined Sanmina as an intern in their Global IT department. Sanmina is a Fortune-500 electronics & medical manufacturing company.</p>
	<p>I dove right in on a few small-scope projects to get my feet wet with the fundamentals of project management and followed closely on the higher-profile projects led by my supervisor. The type of projects included IT infrastructure updates, SaaS application updates, IT security deployments, and proof-of-concept projects used to vet various IT solutions. I had quickly proven myself to the IT leadership, and at the start of my senior year in 2016, I was converted to a full-time employee.</p>	

	<p> My role as an IT Project Manager: I documented project requirements, presented projects for updates and progression amongst CIO staff, created and maintained portfolio roadmaps, tracked project progress and project schedule, identified roles and responsibilities for each project, coordinated communication between the business and IT, and worked alongside project team members to identify and document solutions.</p>
	
</div>





<div className="title">
	<p> SecureAuth </p>
	</div>
<img src={require('./assets/secureauth.png')} alt="SecureAuth" Class="psd2" /> 	

		  <div className="text1">
		  	<p> At the time, Sanmina used a legacy 2FA tool. I led the replacement of it; we partnered with <a href="http://secureauth.com/" target="_blank">SecureAuth</a> for the solution. </p>
			
			<p> The project was broken into phases. The first phase was an initial setup of the tool and a pilot with the North America IT teams.</p>
		  <p> Shortly after the North America pilot, we proceeded with phase 2 - the global roll-out. This targeted roughly 22,000 employees and covered our VPN application, Google Apps, and our homegrown IT helpdesk</p>
		
						  </div>
		  		  		 

<div className="title2">

		<p>Growing Google</p>
	</div>
		   <img src={require('./assets/google.jpeg')} alt="Google Splash" Class="email" /> 	
			<div className="text2">
				
			<p>My personal favorite project, Growing Google had 2 purposes: to increase the usage of Google Apps within the company, and reduce cost by eliminating Microsoft licenses. I had the opportunity to partner with Google and work directly under the CIO. You can read more on the overall strategy <a href="https://gsuite.google.com/customers/sanmina.html"target="_blank">here</a>.</p>
			
			<p>Partnering with Google, our initial project strategized the who, what, when, where, and how. The outcome was an internal marketing pitch, a training plan, and agendas for a pilot. Our two pilot sites were chosen in this discovery phase - Huntsville, Alabama, and Guadalajara, Mexico.</p>
			
			<p>We executed the above in the next phase, and successfully introduced Google Apps where we saw fit - not only were we able to remove 1000+ Microsoft Office licenses, but we increased collaboration due to Google's cloud capability. Pushing the envelope even further, we also successfully implemented 500+ ChromeOS devices across both sites.</p>
			

		</div>	  


</Styles>

	</React.Fragment>
	)